
// // interface AppSettings {
// //   getUrl: () => string;
// //   BASE_URL: () => string;
// // }
// // const AppSettings: AppSettings = {
// //   getUrl: () => {
// //       const currentURL = window.location.href;
// //    //const currentURL = 'https://devreact.gearforneed.com/#/login';
// //     // const currentURL = 'https://valreact.gearforneed.net/member/#/login';//


// //     // Check if the current path contains "devreact", "valreact", or "react"
// //     const isDevReactPath = currentURL.includes('devreact');
// //     const isValReactPath = currentURL.includes('valreact');
// //     const isReactPath = currentURL.includes('react');

// //     // Define base URLs for different environments
// //     let baseDomain;
// //     if (isDevReactPath) {
// //       baseDomain = 'https://devrct.gearforneed.com/api';
// //     } else if (isValReactPath) {
// //       baseDomain = 'https://valrct.gearforneed.com/api';
// //     } else if (isReactPath) {
// //       baseDomain = 'https://gearforneed.com/api';
// //     }

// //     const fullUrl = `${baseDomain}`;

// //     return fullUrl;
// //   },
// //   BASE_URL: () => {
// //     return AppSettings.getUrl();
// //   },
// // };

// // export default AppSettings;
// interface AppSettings {
//   getUrl: () => string;
//   BASE_URL: () => string;
// }
// const AppSettings: AppSettings = {
//   getUrl: () => {
//      const currentURL = window.location.href;
//       // const currentURL = 'https://devrct.gearforneed.com/#/login';
//     // Check if the current path contains "devreact", "valreact", or "react"
//     const isDevReactPath = currentURL.includes('devrct');
//     const isValReactPath = currentURL.includes('valrct');
//     const isReactPath = currentURL.includes('https://gearforneed.com');
//     // Define base URLs for different environments
//     let baseDomain;
//     if (isDevReactPath) {
//         baseDomain = 'https://devrct.gearforneed.com/member/gfn-api';
//     } else if (isValReactPath) {
//       baseDomain = 'https://valrct.gearforneed.com/member/gfn-api';
//     } else if (isReactPath) {
//       baseDomain = 'https://gearforneed.com/member/gfn-api';
//     }
//     const fullUrl = `${baseDomain}`;
//     return fullUrl;
//   },
//   BASE_URL: () => {
//     return AppSettings.getUrl();
//   },
// };
// export default AppSettings;

interface AppSettings {
  getUrl: () => string;
  BASE_URL: () => string;
}

const AppSettings: AppSettings = {
  getUrl: () => {
    const currentURL = window.location.href;
    //  const currentURL = 'https://devrct.gearforneed.com/#/login';
    // const currentURL = 'https://gearforneed.com/#/login';
    // const Locationsurls = currentURL.match(/(https?:\/\/[^\/]*\.com)/) as any;
    // const Locationsurls = currentURL.match(/https?:\/\/[^\/]+/) as any;

    // window.sessionStorage.setItem('Locationsurls', Locationsurls[0])
    const splitPath = currentURL.split('://')[1].split('.');
    const firstPart = splitPath[0];
    const threeChar = firstPart.slice(0, 3)
    const isDevReactPath = threeChar.includes('dev');
    console.log("firstPart", firstPart)
    const isValReactPath = threeChar.includes('val');

    console.log("threeChar", threeChar)
    console.log("isDevReactPath", isDevReactPath)
    // Check if the current path contains "devreact", "valreact", or "react"
    // const isDevReactPath = currentURL.includes('devrct');
    // const isValReactPath = currentURL.includes('valrct');
    const isReactPath = currentURL.includes('https://gearforneed.com');

    // Define base URLs for different environments
    let baseDomain;
    if (isDevReactPath) {
      baseDomain = `https://devapi.gearforneed.com/member/gfn-api`;
    } else if (isValReactPath) {
      baseDomain = `https://valapi.gearforneed.com/member/gfn-api`;
      // } else if (isReactPath) {
      //   baseDomain = `https://api.gearforneed.com/member/gfn-api`;
    } else {
      // baseDomain = "http://192.168.1.197/Finalprod/API/gfn/member/gfn-api"
      baseDomain = `http://api.gearforneed.com/member/gfn-api`;
    }
    const fullUrl = `${baseDomain}`;
    window.sessionStorage.setItem("baseDomain", baseDomain as any);
    let apiRoot;
    if (isDevReactPath) {
      apiRoot = `https://devapi.gearforneed.com`;
    } else if (isValReactPath) {
      apiRoot = `https://valapi.gearforneed.com`;
      // } else if (isReactPath) {
      //   apiRoot = `https://api.gearforneed.com`;
    } else {
      // baseDomain = "http://192.168.1.197/Finalprod/API/gfn"
      apiRoot = `http://api.gearforneed.com`;
    }
    window.sessionStorage.setItem("apiRoot", apiRoot as any);
    return fullUrl;
  },
  BASE_URL: () => {
    return AppSettings.getUrl();
  },
};
export const isDevReactPath = (url: string): boolean => {
  return url.includes('devrct');
};

export const isValReactPath = (url: string): boolean => {
  return url.includes('valrct');
};

export const isReactPath = (url: string): boolean => {
  return url.includes('https://gearforneed.com');
};

export default AppSettings;

